<template>
  <a
    :class="color === 'blue' ? 'more-btn blue-btn' : 'more-btn green-btn'"
    class="co-button"
    @click="openWindow(href)"
  >
    <slot></slot>
    <img v-show="arrow" class="logo" src="../../assets/img/home/1.png" />
  </a>
</template>

<script>
export default {
  name: "co-button",
  data() {
    return {};
  },
  props: {
    color: {
      type: String,
      default: "blue",
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: "",
    },
  },
  methods: {
    openWindow(href) {
      if (href) {
        window.open(href, "_blank");
      }
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.more-btn {
  display: inline-block;
  font-size: 18px;
  padding: 0 24px;
  line-height: 40px;
  text-align: center;
  min-width: 10vw;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  .logo {
    width: 3vw;
    padding-left: 1vw;
  }
}
.blue-btn {
  background: #2191d0;
}
.green-btn {
  background: #85c358;
}
@media (max-width: 768px) {
  .more-btn {
    display: inline-block;
    font-size: 3.5vw;
    padding: 0 2vw;
    line-height: 7.3vw;
    text-align: center;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    // width: 22vw;
    .logo {
      width: 5vw;
      padding-left: 2vw;
    }
  }
}
</style>
